<script setup lang="ts">
import type { LimitedEvent } from "mws-ts-v2-sdk";

defineProps<{ event: LimitedEvent }>();
</script>

<template>
  <div
    class="flex justify-start items-center gap-2 w-full md:flex-row-reverse md:gap-1 md:justify-between"
  >
    <NuxtImg
      provider="imgix"
      preset="logoMedium"
      :alt="`${event.name} logo`"
      :src="event.logoUrl || logoFallbackPath"
      class="w-6 h-6 md:w-8 md:h-8 object-contain"
    />
    <div class="flex flex-col gap-1">
      <EventName
        :event="event"
        class="gap-1 leading-5"
      >
        <template #forcedName="{ eventName }">
          <p class="font-semibold md:font-normal">
            {{ eventName }}
          </p>
        </template>
      </EventName>

      <EventCardDateDisplay
        :event="event"
        :show-finished-text="true"
      />
    </div>
  </div>
</template>
